import { productEmbedType } from './analyticsWebTypes';
import type { FirstPartyProductEmbedContext, ProductEmbeddedContext } from './types';

export const isFirstParty = (
	input: ProductEmbeddedContext,
): input is FirstPartyProductEmbedContext => {
	return (
		input.embeddedType === productEmbedType.FIRST_PARTY && input.embeddedFromProduct !== undefined
	);
};
